import { gql } from "@apollo/client";

// Surveys (see wfc-server service/surveyService). Every response is { message, response }
// with response as JSON. getSurveyByToken is public (the emailed link - no login).

export const getSurveySettingsQuery = gql`
    query getSurveySettings{
        getSurveySettings{
            message
            response
        }
    }
`;

export const getSurveysQuery = gql`
    query getSurveys($filter: SurveyListFilter){
        getSurveys(filter: $filter){
            message
            response
        }
    }
`;

export const getSurveyOverviewQuery = gql`
    query getSurveyOverview{
        getSurveyOverview{
            message
            response
        }
    }
`;

export const getSurveyResultsQuery = gql`
    query getSurveyResults($id: String!){
        getSurveyResults(id: $id){
            message
            response
        }
    }
`;

export const getSurveyResponseQuery = gql`
    query getSurveyResponse($responseId: String!){
        getSurveyResponse(responseId: $responseId){
            message
            response
        }
    }
`;

export const getSurveysForRecordQuery = gql`
    query getSurveysForRecord($respondentType: String!, $respondentId: String!){
        getSurveysForRecord(respondentType: $respondentType, respondentId: $respondentId){
            message
            response
        }
    }
`;

export const getSurveySchedulesQuery = gql`
    query getSurveySchedules{
        getSurveySchedules{
            message
            response
        }
    }
`;

export const getSurveyAudienceOptionsQuery = gql`
    query getSurveyAudienceOptions{
        getSurveyAudienceOptions{
            message
            response
        }
    }
`;

export const previewSurveyAudienceQuery = gql`
    query previewSurveyAudience($audience: SurveyAudienceInput!){
        previewSurveyAudience(audience: $audience){
            message
            response
        }
    }
`;

export const getMySurveysQuery = gql`
    query getMySurveys{
        getMySurveys{
            message
            response
        }
    }
`;

export const getMySurveyQuery = gql`
    query getMySurvey($responseId: String!){
        getMySurvey(responseId: $responseId){
            message
            response
        }
    }
`;

export const getSurveyByTokenQuery = gql`
    query getSurveyByToken($token: String!){
        getSurveyByToken(token: $token){
            message
            response
        }
    }
`;

// two-way surveys: who can answer our side (Send survey form), and the reviews waiting on me
export const getSurveyOurSideOptionsQuery = gql`
    query getSurveyOurSideOptions($ourRole: String){
        getSurveyOurSideOptions(ourRole: $ourRole){
            message
            response
        }
    }
`;

export const getOurSideSurveysQuery = gql`
    query getOurSideSurveys{
        getOurSideSurveys{
            message
            response
        }
    }
`;

export const getOurSideSurveyQuery = gql`
    query getOurSideSurvey($responseId: String!){
        getOurSideSurvey(responseId: $responseId){
            message
            response
        }
    }
`;
